module.exports = __webpack_public_path__ + "img/award-simple.0a18c46a.svg";